import React from 'react'

import { bool, object, func } from 'prop-types'

import Layout from 'Pods/Profile/Layout/Layout'
import UploaderNav from 'Pods/Profile/Products/UploaderNav'
import TutorialWidget from 'Pods/Shared/TutorialWidget/TutorialWidget'
import withRouter from 'Pods/Shared/withRouter'

import ModelPublisher from './Components/ModelPublisher'

class ModelUploader extends React.Component {
  constructor() {
    super()

    this.state = { modelId: '' }
  }

  componentDidMount() {
    const { match } = this.props
    this.setState({ modelId: match.params.id })
  }

  render() {
    const { newRoyaltyUi, isEditingMode, participatesInMqs, onViewToggle, cadProductTypeEnabled } = this.props
    const { modelId } = this.state

    return (
      <Layout activeBreadcrumb="Model Upload" hideUploadButton newRoyaltyUi={newRoyaltyUi}>
        <TutorialWidget videoId="nTrCqfxoHnQ" />
        <UploaderNav editableModelId={modelId} />

        <ModelPublisher
          modelId={modelId}
          isEditingMode={isEditingMode}
          participatesInMqs={participatesInMqs}
          onViewToggle={onViewToggle}
          cadProductTypeEnabled={cadProductTypeEnabled}
        />
      </Layout>
    )
  }
}

ModelUploader.propTypes = {
  participatesInMqs: bool.isRequired,
  isEditingMode: bool,
  newRoyaltyUi: bool,
  match: object.isRequired,
  onViewToggle: func,
  cadProductTypeEnabled: bool,
}

ModelUploader.defaultProps = {
  isEditingMode: false,
  newRoyaltyUi: false,
  onViewToggle: undefined,
  cadProductTypeEnabled: false,
}

export default withRouter(ModelUploader)
